var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-6"},[_c('em',[_vm._v("Noch nicht implementiert 🤷‍♂️")])])])
}]

export { render, staticRenderFns }